import { render, staticRenderFns } from "./courseSign.vue?vue&type=template&id=bbe695ae&scoped=true&"
import script from "./courseSign.vue?vue&type=script&lang=js&"
export * from "./courseSign.vue?vue&type=script&lang=js&"
import style0 from "./courseSign.vue?vue&type=style&index=0&id=bbe695ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe695ae",
  null
  
)

export default component.exports